(function() { window.GUID_32ef4b17_3446_4a73_97df_294ff06a039f = { getGuid: function() { return "32ef4b17-3446-4a73-97df-294ff06a039f"; } }; })();
var CompuSport;
(function (CompuSport) {
    class BundleLoader {
        constructor(DynamicBundles) {
            this.DynamicBundles = DynamicBundles;
            this.styleCount = 0;
            this.scriptCount = 0;
            if (this.DynamicBundles.Scripts != null) {
                this.loadScript();
            }
            if (this.DynamicBundles.Styles != null) {
                this.loadStyle();
            }
        }
        loadScript() {
            let documentScripts = $('script');
            for (let iBundle = 0; iBundle < this.DynamicBundles.Scripts.length; iBundle++) {
                let bundle = $(this.DynamicBundles.Scripts[iBundle]);
                let found = false;
                for (let iDoc = 0; iDoc < documentScripts.length; iDoc++) {
                    let script = documentScripts[iDoc];
                    bundle.each((i, ele) => {
                        if (ele.src === script.src) {
                            found = true;
                        }
                    });
                }
                if (found === false) {
                    $(document.body).append(bundle);
                    this.scriptCount += bundle.length;
                }
            }
        }
        loadStyle() {
            var documentLinks = $('link');
            for (let iBundle = 0; iBundle < this.DynamicBundles.Styles.length; iBundle++) {
                if (!this.DynamicBundles.Styles[iBundle]) {
                    continue;
                }
                //Convert the string bundle to element 
                let bundle = $(this.DynamicBundles.Styles[iBundle]);
                let found = false;
                for (let iDoc = 0; iDoc < documentLinks.length; iDoc++) {
                    let sheet = documentLinks[iDoc];
                    bundle.each((i, ele) => {
                        if (ele.href === sheet.href) {
                            found = true;
                        }
                    });
                }
                if (found === false) {
                    if (typeof (CompuSport) != "undefined" && typeof (CompuSport.IsDebug) != "undefined") {
                        var tickDate = Date.now().toString();
                        //force un refresh du bundle comme si on était en prod
                        bundle[0].href = bundle[0].href + "?dummyDate=" + tickDate;
                    }
                    $(document.head).append(bundle);
                    this.styleCount += bundle.length;
                }
            }
        }
    }
    CompuSport.BundleLoader = BundleLoader;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=BundleLoader.js.map
